import type { Props } from "./types";

function SegmentedGauge({
  segments = [],
  showSegmentLabels = true,
  className,
  ariaLabel = ""
}: Readonly<Props>) {
  return (
    <div className={["w-full select-none", className || ""].join(" ")}>
      {/* Native accessible meter for screen readers */}
      <meter className="sr-only" min={0} max={100} aria-label={ariaLabel} />
      <div className="relative w-full">
        <div className="relative h-3 w-full overflow-hidden rounded-3 bg-gray-200">
          <div className="flex h-full w-full">
            {segments.map((segment) => {
              const widthPct = segment.weight * 100;

              return (
                <div
                  key={segment.key}
                  className="h-full"
                  style={{
                    width: `${widthPct}%`,
                    backgroundColor: segment.color
                  }}
                />
              );
            })}
          </div>
        </div>
      </div>

      {showSegmentLabels && (
        <div className="mt-2 flex w-full justify-between  text-gray-600">
          {segments.map((segment) => (
            <div key={segment.key} className="flex items-center gap-1">
              <span
                className="inline-block h-2 w-2 rounded-full"
                style={{ backgroundColor: segment.color }}
                aria-hidden
              />

              <span className="text-xs font-medium mr-2 text-[#8c97a7]">
                {segment.label ?? segment.key}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default SegmentedGauge;
